import { render, staticRenderFns } from "./propertyModal.vue?vue&type=template&id=705489e8"
import script from "./propertyModal.vue?vue&type=script&lang=js"
export * from "./propertyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports